import { useSelector } from 'react-redux';

import { RootState } from '../redux/rootReducer';
import { CardTemplateShapeDb } from '../redux/cardTemplateShapeDbSlice';

const useCardTemplateShapeDbs = (cardTemplateId: string): [string[], CardTemplateShapeDb[]] => {
  const cardTemplateShapeDb = useSelector((state: RootState) => state.cardTemplateShapeDb);
  const ids = Object.keys(cardTemplateShapeDb.cardTemplateShapes).filter(id => cardTemplateShapeDb.cardTemplateShapes[id].cardTemplateId === cardTemplateId);
  ids.sort((a, b) => {
    const aValue = cardTemplateShapeDb.cardTemplateShapes[a];
    const bValue = cardTemplateShapeDb.cardTemplateShapes[b];
    return bValue.z - aValue.z;
  })
  const values = ids.map(id => cardTemplateShapeDb.cardTemplateShapes[id]);

  return [ids, values];
}

export default useCardTemplateShapeDbs;
